module.exports = {"510105002":"草市街街道","510105003":"西御河街道","510105005":"少城街道","510105007":"草堂街道","510105008":"府南街道","510105009":"光华街道","510105011":"金沙街道","510105012":"黄田坝街道","510105013":"苏坡街道","510105014":"文家街道","510105018":"蔡桥街道","510105019":"康河街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510105.json
// module id = 2383
// module chunks = 0